<template>
  <div class="login-wrap">
    <div class="login-margin">
      <div class="login-box">
        <div class="logo-wrap">
          <img class="logo" src="./logo.png"/>{{$t('title')}}
        </div>
        <el-form size="lager" :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0px">
          <el-form-item prop="loginName">
            <el-input prefix-icon="el-icon-user" v-model.trim="loginForm.username" ref="loginName"
                      placeholder="用户名/邮箱" @keyup.enter.native="submitForm('loginForm')"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input prefix-icon="el-icon-lock" type="password" placeholder="密码" v-model.trim="loginForm.password"
                      @keyup.enter.native="submitForm('loginForm')"></el-input>
          </el-form-item>
          <div class="login-btn">
            <el-button type="primary" @click="submitForm('loginForm')" :loading="loging">登录</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <img src="./login-right.png" class="login-right">
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="660px">
      <p>建议使用google chrome或者Firefox浏览器，如您的浏览器不是推荐版本。请点击以下链接进行下载</p>
      <a style="display: inline-block;padding-right: 20px" href="https://www.google.cn/chrome/index.html">chrome点击此处下载</a>
      <a href="https://www.firefox.com.cn/">Firefox点击此处下载</a>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
  import { login } from "@/api/remote";

  export default {
    components: {},
    name: 'login',
    data: function () {
      return {
        loging: false,
        loginForm: {
          username: '',
          password: ''
        },
        loginRules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ]
        },
        dialogVisible: false
      }
    },
    created(){
      sessionStorage.clear();
      localStorage.clear()
    },
    methods: {
      handleClose(done) {
        this.$confirm('确认关闭？')
            .then(_ => {
              done();
            })
            .catch(_ => {});
      },
      myBrowser(){
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        var isOpera = userAgent.indexOf("Opera") > -1;
        if (isOpera) {
          return "Opera"
        } //判断是否Opera浏览器
        if (userAgent.indexOf("Firefox") > -1) {
          return "FF";
        } //判断是否Firefox浏览器
        if (userAgent.indexOf("Chrome") > -1){
          return "Chrome";
        }
        if (userAgent.indexOf("Safari") > -1) {
          return "Safari";
        } //判断是否Safari浏览器
        if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
          return "IE";
        } //判断是否IE浏览器
      },
      submitForm(formName) {
        this.$refs[formName].validate().then(() => {
          this.loging = true;
          login(this.loginForm).then(res => {
            localStorage.clear();
            let user = res.data;
            localStorage.setItem('access_token', user.token);
            this.$store.commit('setToken', user.token);
            delete user.token;
            localStorage.setItem('user_info', JSON.stringify(user));
            this.$store.commit('setUserInfo', user);
            let formData = {
              distributorName:res.data.distributorName
            }
            this.$store.commit('setFormData', formData);
            sessionStorage.formData = JSON.stringify(formData);
             this.$router.push({ name: 'index', params:{ tid: 1 } })
            this.loging = false;
          }, () => { this.loging = false });
        });
      }
    },
    mounted() {
      this.$refs.loginName.focus();
      var mb = this.myBrowser();
      if (mb !== "Chrome" && mb !== "FF") {
        this.dialogVisible = true
      }
/*      if (mb === "Chrome") {
        alert("我是 Chrome");
      }*/
    },
    watch:{
      $route:{
        handler(val,oldval){
          console.log(val.name)
        },
        deep:true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-wrap {
    background-color: #f2f1f8;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(background.png);
  }

  .login-right {
    width: 340px;
    background: #ffffff;
    border-radius: 0 16px 16px 0;
  }

  .login-margin {
    width: 420px;
    height: 426px;
    border-radius: 16px 0 0 16px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo-wrap {
    padding: 0px 0 40px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #515153;
    font-weight: 600;
    font-size: 22px;
  }

  .logo {
    height: 32px;
    padding-right: 10px;
  }

  .login-box {
    width: 298px;
  }

  .el-form-item--mini.el-form-item {
    margin-bottom: 20px;
  }

  .login-btn {
    text-align: center;
  }

  .login-btn button {
    width: 100%;
    height: 36px;
  }

  .qrcode {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qrcode-item {
    width: 50%;
    /*padding: 6px;*/
    text-align: center;

    img {
      width: 200px;
    }
  }

</style>
